import { useCallback, useMemo } from 'react';
import { EDGE_API } from '~/lib/constants';
import { useTenant, useAnalytics } from '@parcel2go/npm-p2g-app';
import { isEmail } from '@parcel2go/core-ui';
import { useAuth } from 'react-oidc-context';
import { authenticatedFetchWithTenantAnalytics } from '~/lib/fetch';
import { Account } from '~/lib/types/basket-types';
import { BasketSections } from '~/lib/types/enums';
import useBasketSection from '~/hooks/use-basket-section';
import { SenderTypes, SenderTypesConst } from './sender-type-types';
import useWorkflowActions from '~/hooks/use-workflow-actions';

export default function useSenderTypePersister() {
  const { user } = useAuth();
  const account = useBasketSection<Account>({ name: BasketSections.ACCOUNT });
  const { tenant, settings } = useTenant();
  const { session } = useAnalytics();
  const { workflowData } = useWorkflowActions();

  const value = useMemo(() => {
    const v = workflowData.get('SENDER-TYPE');
    if (typeof v === 'string') {
      return v;
    }
  }, [workflowData]);

  const persist = useCallback(async () => {
    if (value && isEmail(account.data?.email || '') && SenderTypes.includes(value)) {
      return await authenticatedFetchWithTenantAnalytics(
        user,
        tenant,
        settings,
        session,
        `${EDGE_API}/${tenant}/order-process/sender-type/store`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            isBusiness: value === SenderTypesConst.Business ? true : false,
            email: account.data.email
          })
        }
      ).then((res) => res.json());
    }
  }, [account.data.email, user, tenant, settings, session, value]);

  return {
    persist
  };
}
